package com.cs.ejobin.model

data class UserProfile(
    val email: String,
    val id: String,
    val name: String,
    val phone: String,
    val skills: List<Skill>,
    val isAvailable: Boolean,
    val photoUrl: String? = null,
    val description: String? = ""
)